import React, { useState, useEffect } from 'react';
import styles from './Components/CSS/BottomBanner.module.css';
import Loading from '../common/HousGlass Loader/Loading';
import { useNavigate } from 'react-router-dom';

const BottomBanner = ({ series, loading }) => {
  const [currentDetail, setCurrentDetail] = useState(null);
  const navigate=useNavigate()
  
  useEffect(() => {
    if (series && series.length > 0) {
      setCurrentDetail({
        title: series[0].title,
        description: series[0].description,
        image: series[0].coverImageUrl,
        slug: series[0].slug,
        isPremium: series[0].isPremium,
        category: series[0].category
      });
    }
  }, [series]);
  
  if (loading || !currentDetail) {
    return <div className={styles.loading}><Loading/></div>;
  }

  const handleOptionClick = (item) => {
    setCurrentDetail({
      title: item.title,
      description: item.description,
      image: item.coverImageUrl,
      slug: item.slug,
      isPremium: item.isPremium,
      category: item.category
    });
  };

  return (
    <div className={styles.bannerContainer}>
      <div className={styles.banner}>
        {/* Left Section */}
        <div className={styles.bannerLeft}>
          <div className={styles.contentBox}>
            <h1 className={styles.heading}>{currentDetail.title}</h1>
            <p className={styles.subheading}>{currentDetail.description}</p>
            <div className={styles.category}>
              {currentDetail.isPremium ? 'Premium' : 'Free'} | {currentDetail.category?.name || 'Audio'}
            </div>
            <button className={styles.btn} onClick={() => navigate(`/audio-play/${currentDetail.slug}`)}>
              <svg className={styles.playIcon} viewBox="0 0 24 24" width="24" height="24">
                <path fill="currentColor" d="M8 5v14l11-7z" />
              </svg>
              Listen Now
            </button>
          </div>
        </div>
        
        {/* Right Section */}
        <div className={styles.bannerRight}>
          <img
            className={styles.episodeMainImage}
            src={currentDetail.image}
            alt={currentDetail.title}
          />
          <div className={styles.optionsContainer}>
            {series.slice(0, 8).map((item) => (
              <div
                key={item.id}
                className={styles.option}
                onClick={() => handleOptionClick(item)}
              >
                <img
                  src={item.coverImageUrl}
                  alt={item.title}
                  className={styles.optionImage}
                />
                <div className={styles.optionDetails}>
                  <h3 className={styles.optionTitle}>{item.title}</h3>
                  <p className={styles.optionSubtitle}>
                    {item.category?.name || 'Audio Series'}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomBanner;